import { render, staticRenderFns } from "./GItemLineupImage.vue?vue&type=template&id=6a7c84e2&scoped=true&"
import script from "./GItemLineupImage.vue?vue&type=script&lang=ts&"
export * from "./GItemLineupImage.vue?vue&type=script&lang=ts&"
import style0 from "./GItemLineupImage.vue?vue&type=style&index=0&id=6a7c84e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c84e2",
  null
  
)

export default component.exports